import React from "react";
import { useSelector } from "react-redux";
import './OutstandingSummary.css';

const OutstandingSummary = () => {
  const { GetCustMaster } = useSelector(
    (state) => state.CustomerMaster
  );

  const customer = GetCustMaster?.getCustomerMasters?.[0];

  const {
    balance,
    aged45Days,
    aged75Days,
    agedMoreThan75Days,
    lastPaymentAmount,
    lastPaymentDate,
    creditLimit,
  } = customer;

  const overDue30 = aged45Days + aged75Days + agedMoreThan75Days;
  const overDue60 = aged75Days + agedMoreThan75Days;

  const formatCurrency = (value) =>
    value?.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });

  return (
    <div className="card border-0 outstanding-summary-card">
      <div className="card-body">
        <h5 className="card-title fw-semibold mb-4">
          Outstanding Summary
        </h5>

        <div className="row g-3">
          <SummaryItem
            label="Current Outstanding"
            value={formatCurrency(balance)}
          />
          <SummaryItem
            label="Over Due (30 Days Above)"
            value={formatCurrency(overDue30)}
          />
          <SummaryItem
            label="Over Due (60 Days Above)"
            value={formatCurrency(overDue60)}
          />
          <SummaryItem
            label="Last Payment Value"
            value={formatCurrency(lastPaymentAmount)}
          />
          <SummaryItem
            label="Last Payment Date"
            value={lastPaymentDate}
          />
          <SummaryItem
            label="Credit Limit"
            value={formatCurrency(creditLimit)}
          />
        </div>
      </div>
    </div>
  );
};

const SummaryItem = ({ label, value }) => (
  <div className="col-12">
    <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
      <span className="os-label">{label}</span>
      <span className="os-value">{value}</span>
    </div>
  </div>
);

export default OutstandingSummary;
